var getFlagrBaseUrl = function () { var _a; return (_a = window.EDUCATOR_ENV) === null || _a === void 0 ? void 0 : _a.REACT_APP_FLAGR_BASE_URL; };
var getLoadFeaturesUrl = function () {
    var flagrBaseUrl = getFlagrBaseUrl();
    if (flagrBaseUrl) {
        return getFlagrBaseUrl() + "evaluation/batch";
    }
    return null;
};
export default getLoadFeaturesUrl;
